import { createContext } from 'react';

export default createContext({
  language: {
    langPrefix: 'en',
    shortLangPrefix: 'en',
    urlLangPrefix: '',
    i18nKey: 'en',
    i18n: () => {}
  },
  location: {
    pathname: ''
  },
  marketo: {
    getMarketoModal: () => {},
    getMarketoFields: () => {}
  },
  abTesting: {
    updateTest: () => {}
  },
  modal: {
    openModal: () => {}
  },
  video: {
    getVideoModal: () => {}
  }
});
